<template>
  <div style="overflow: hidden">
    <div class="mb-6" v-if="content.notes.length > 0">
      <h4 class="note-title">{{ content.title }}</h4>
      <div
        v-for="(item, index) in content.notes"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
        :key="index"
      >
        <p class="note" v-if="item">{{ index + 1 }}- {{ item }}</p>
      </div>
    </div>
    <vs-button @click="toggleModalVisibility()" color="secondary" block
      >ایجاد یادداشت</vs-button
    >

    <div v-if="modalVisible">
      <vs-popup title="افزودن یادداشت" :active.sync="modalVisible">
        <notes-popup @noteConfirmed="submitNote" :note="content" />
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import providerApiService from "../../../services/api/ProviderApiService";
import NotesPopup from "./NotesPopup.vue";

export default {
  name: "Input",
  components: { NotesPopup },
  data() {
    return {
      modalVisible: false,
      content: {
        title: "",
        notes: [],
      },
      noteId: null,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    fetchData() {
      providerApiService
        .getProviderNotes(this.currentProvider.id)
        .then((notes) => {
          this.noteId = notes.id;
          this.content = notes.content || { title: "", notes: [] };
        });
    },
    toggleModalVisibility() {
      this.modalVisible = !this.modalVisible;
    },
    submitNote(note) {
      this.$vs.loading();
      providerApiService
        .submitProviderNotes(this.currentProvider.id, note, this.noteId)
        .then((result) => {
          this.noteId = result.resource.id;
          this.content = result.resource.content;
          this.toggleModalVisibility();
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.fetchData();
  },
  props: {
    note: {
      type: Object,
      requried: true,
    },
  },
};
</script>

<style scoped lang="scss">
.note,
.note-title {
  margin: 10px 0;
  text-align: left;
  white-space: pre-line;
}
</style>
